<template>
    <bottom-sheet v-model="shows" v-bind="{ title }" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="bottom-sheet__contents h-100">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary">
                <vertical-form-table v-model="form" v-bind="{ items }" class="mb-20 mb-lg-40 mx-8" @input="emit">
                    <template #근로계약>
                        <autocomplete-employment-contract
                            v-model="form._contract"
                            v-bind="{
                                ...attrs_input,
                                itemText: ({ subject, application }) => [application?.resume?.personalInformation?.name, subject].join(' - '),
                                params: params_contract,
                            }"
                            @input="emit"
                        />
                    </template>
                </vertical-form-table>
            </v-sheet>
            <div class="v-btn-group flex-wrap">
                <v-btn outlined color="grey-d" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="shows = false"><span class="grey-6--text">취소하기</span></v-btn>
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" v-bind="{ loading }" @click="save">
                    <template v-if="isCreate">
                        <span> 생성하기 </span>
                    </template>
                    <template v-else>
                        <span> 수정하기 </span>
                    </template>
                </v-btn>
            </div>
        </v-layout>
        <client-loader v-bind="{ loading }" />
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import dayjs from "@/plugins/vue-dayjs";
import { attrs_input } from "@/assets/variables";
import { ATTENDANCE_LOG_TYPES, initAttendanceLog } from "@/store/attendance";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import AutocompleteEmploymentContract from "@/components/dumb/autocomplete-employment-contract.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        VerticalFormTable,
        AutocompleteEmploymentContract,
    },
    props: {
        value: { type: Object, default: () => initAttendanceLog({ isManual: true, date: dayjs().toISOString() }) },
    },
    data: () => ({
        form: initAttendanceLog({ isManual: true }),

        shows: false,
        loading: false,

        attrs_input,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
        title() {
            let title = "근로계약 출근내역";
            if (this.isCreate) title += " 생성하기";
            else title += " 수정하기";
            return title;
        },
        items() {
            return [
                {
                    key: "_contract",
                    term: "근로계약",
                    required: true,
                },
                {
                    key: "type",
                    term: "유형",
                    type: "select",
                    items: Object.values(ATTENDANCE_LOG_TYPES),
                    required: true,
                },
                {
                    key: "date",
                    term: "일시",
                    type: "datetime",
                    required: true,
                },
            ].map((item) => ({ ...attrs_input, ...item }));
        },
        params_contract() {
            return {
                isSigned: true,
            };
        },
    },
    methods: {
        async init() {
            this.loading = false;
            if (this.isCreate) this.form = initAttendanceLog({ isManual: true, date: dayjs().toISOString() });
            else {
                if (this.loading) return;
                else this.loading = true;

                try {
                    const { log } = await api.v1.company.attendance.logs.get({ _id: this.value?._id });
                    this.$emit("input", log);
                    this.form = initAttendanceLog(log);
                } finally {
                    this.loading = false;
                }
            }
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                let { post, put } = api.v1.company.attendance.logs;
                let { log } = await (this.isCreate ? post : put)(form);

                this.form = initAttendanceLog(log);
                this.$emit("input", log);
                this.$emit("search");
                alert(this.isCreate ? "생성되었습니다" : "수정되었습니다");
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        setLoading(loading) {
            this.loading = loading;
        },

        emit() {
            this.form = initAttendanceLog(this.form);
        },

        exit() {
            this.shows = false;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
